// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iSxQ","label":"styles_label__s3Wzs"};